export const DOCUMENT_TYPE_COMPLAINT_GUIDE_FRONTPAGE =
	'complaintGuide-frontpage';
